export enum PartnerType {
  FGTS = "FGTS",
  SALVCAR = "SALVCAR",
  CREFAZ = "CREFAZ",
  CREFISA = "CREFISA",
  PAN = "PAN",
}
